export enum TemplateConstants {
  RecoveryCode = 'recovery_code',
  ClientName = 'client_name',
  AgentName = 'agent_name',
  Date = 'date',
  Time = 'time',
  ObjectName = 'object_name',
  ObjectLink = 'object_link',
  AppointmentType = 'appointment_type',
  AppointmentDate = 'appointment_date',
  Message = 'message',
  Subject = 'subject',
  Phone = 'phone',
  Email = 'email',
  Comment = 'comment',
  InviteLink = 'invite_link',
  InviterName = 'inviter_name',
  CntactName = 'contact_name',
  ContactLink = 'contact_link',
  ProjectLinks = 'project_links',
  ApartmentTypes = 'apartment_types',
  Macrozones = 'macrozones',
  PersonalManager = 'personal_manager',
  PriceMin = 'price_min',
  PriceMax = 'price_max',
  PurchaseTiming = 'purchase_timing',
}
